document.addEventListener("DOMContentLoaded", function () {
  const slides = document.querySelectorAll(".carousel-slide");
  const dots = document.querySelectorAll(".carousel-dots .dot");
  const slideWrapper = document.querySelector(".carousel-slides");

  if (slides.length <= 1 || !slideWrapper) return;

  let current = 0;
  const duration = 10000;
  let autoRotate = setInterval(nextSlide, duration);

  let startX = 0;
  let endX = 0;
  const swipeThreshold = 50; // px required to trigger swipe

  function updateCarousel(index) {
    const offset = index * -100;
    slideWrapper.style.transform = `translateX(${offset}%)`;

    dots.forEach((dot, i) => {
      dot.classList.toggle("active", i === index);
    });
  }

  function nextSlide() {
    current = (current + 1) % slides.length;
    updateCarousel(current);
  }

  function prevSlide() {
    current = (current - 1 + slides.length) % slides.length;
    updateCarousel(current);
  }

  function resetAutoRotate() {
    clearInterval(autoRotate);
    autoRotate = setInterval(nextSlide, duration);
  }

  // Dot navigation
  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => {
      current = index;
      updateCarousel(current);
      resetAutoRotate();
    });
  });

  /* ===== Touch Events (Mobile) ===== */
  slideWrapper.addEventListener("touchstart", (e) => {
    startX = e.touches[0].clientX;
  }, { passive: true });

  slideWrapper.addEventListener("touchend", (e) => {
    endX = e.changedTouches[0].clientX;
    handleSwipe();
  });

  /* ===== Mouse Drag (Desktop Optional) ===== */
  let isDragging = false;

  slideWrapper.addEventListener("mousedown", (e) => {
    isDragging = true;
    startX = e.clientX;
  });

  slideWrapper.addEventListener("mouseup", (e) => {
    if (!isDragging) return;
    endX = e.clientX;
    isDragging = false;
    handleSwipe();
  });

  slideWrapper.addEventListener("mouseleave", () => {
    isDragging = false;
  });

  function handleSwipe() {
    const distance = startX - endX;

    if (Math.abs(distance) < swipeThreshold) return;

    if (distance > 0) {
      nextSlide(); // swipe left
    } else {
      prevSlide(); // swipe right
    }

    resetAutoRotate();
  }

  // Initialize
  updateCarousel(current);
});
